export default __webpack_public_path__ + "svgs/focus_online-db90ebda.svg";